var map6142c6395bc744bd98491e3cbbbf885e;

    function LoadMap6142c6395bc744bd98491e3cbbbf885eGetLang(lang){

        var latlang = {
            pl : [ 51.1518208, 19.1568873],
            de : [ 51.7484760, 14.3332850],
            cz : [ 49.8271081, 18.2504585],
            //de : [ 51.1523533, 14.9286311]//Görlitz
        };

        if(lang == 'pl') {
            return latlang.pl;
        }
        else if(lang == 'cz'){
            return latlang.cz;
        }
        else{
            return latlang.de;
        }
    }
    function LoadMap6142c6395bc744bd98491e3cbbbf885eGetLangOffsets(lang){

        var latlang = {
            pl : [ 51.1518208, 19.1568873],
            de : [ 51.8123533, 13.0],
            cz : [ 49.8271081, 18.2504585],
        };

        if(lang == 'pl') {
            return latlang.pl;
        }
        else if(lang == 'cz'){
            return latlang.cz;
        }
        else{
            return latlang.de;
        }
    }


    function LoadMap6142c6395bc744bd98491e3cbbbf885e(lang) {

        latslang = LoadMap6142c6395bc744bd98491e3cbbbf885eGetLang(lang);
        latslangoffset = LoadMap6142c6395bc744bd98491e3cbbbf885eGetLangOffsets(lang);

        var gmapdiv = document.createElement('div');
        gmapdiv.id ='gmapid-6142c639-5bc7-44bd-9849-1e3cbbbf885e';
        gmapdiv.style.width = '100%';
        gmapdiv.style.height = '400px';
        document.getElementById('mapid-6142c639-5bc7-44bd-9849-1e3cbbbf885e').appendChild(gmapdiv);

        var mapcenter = new google.maps.LatLng(latslang[0], latslang[1]);
        var mapOptions = {
            zoom: 7,
            center: new google.maps.LatLng(latslangoffset[0], latslangoffset[1]),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [{"featureType":"landscape","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","stylers":[{"saturation":-100},{"lightness":51},{"visibility":"simplified"}]},{"featureType":"road.highway","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"road.arterial","stylers":[{"saturation":-100},{"lightness":30},{"visibility":"on"}]},{"featureType":"road.local","stylers":[{"saturation":-100},{"lightness":40},{"visibility":"on"}]},{"featureType":"transit","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"administrative.province","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"on"},{"lightness":-25},{"saturation":-100}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]}]
        };              
               
        mapOptions.mapTypeControl = true;
        mapOptions.zoomControl = true;
        mapOptions.zoomControlOptions = {style: google.maps.ZoomControlStyle.SMALL};

        mapOptions.overviewMapControl = true;
        mapOptions.scaleControl = true;

        map6142c6395bc744bd98491e3cbbbf885e = new google.maps.Map(document.getElementById('gmapid-6142c639-5bc7-44bd-9849-1e3cbbbf885e'), mapOptions);  

var icon10202290 = { url: '//www.versanis.pl/media/web/default/images/versanis_marker.png', origin: new google.maps.Point(0,0)};
var shadow10202290 = { origin: new google.maps.Point(0,0)};


var pointGDynamicMarker28120988 = new google.maps.LatLng(latslang[0], latslang[1]);

var GDynamicMarker28120988 = new google.maps.Marker({position: pointGDynamicMarker28120988,map: map6142c6395bc744bd98491e3cbbbf885e,icon: icon10202290,
shadow: shadow10202290,
draggable: false});

var GDynamicMarker28120988InfoWindow = new google.maps.InfoWindow({content: 'Versanis'});google.maps.event.addListener(GDynamicMarker28120988, 'click', function() { GDynamicMarker28120988InfoWindow.open(map6142c6395bc744bd98491e3cbbbf885e,GDynamicMarker28120988);});


    }
